import {SortState} from "../../sorting/SortState";
import {addTimeOpen} from "../idea/timeOpenCalculator";
import {Clock} from "js-joda";
import {hideNotifications} from "../../notification/notificationActions";
import {setEarningsSortPriorityValues} from "../earnings/earnings";

export const INITIAL_STATE = {
    createModalVisible: false,
    content: null,
    openIdeasSort: new SortState("timeOpenMillis", "desc", false),
    portfolioSort: new SortState("portfolioName", null),
    openIdeasPerformance: null,
    editingIdeaId: null,
    selectedIdeaAction: null,
};

export const IDEA_ACTIONS = {
    close: "Close",
    minus_50: "50%",
    minus_25: "25%",
    plus_25: "25%",
    plus_50: "50%",
    plus_100: "100%",
};

export function addTimeOpenToIdeas(ideas) {
    if (!ideas) return ideas;

    return ideas.map(idea => {
        const updatedIdea = addTimeOpen(idea, Clock.systemDefaultZone());
        updatedIdea.portfolioCount = updatedIdea.portfolioDetails ? updatedIdea.portfolioDetails.length : 0;
        return updatedIdea;
    });
}

function addEarningsSort(ideas) {
    if (!ideas) return ideas;

    return ideas.map(idea => {
        const earnings = {
            previousEarnings: idea.previousEarnings,
            nextEarnings: idea.nextEarnings
        }
        return {
            ...idea,
            earningsSort: setEarningsSortPriorityValues(earnings)
        };
    });
}

function addPerformance(openIdeas, ideaPerformance) {
    if (!openIdeas)
        return openIdeas;
    if (!ideaPerformance) {
        return openIdeas.map(idea => ({...idea, stockEntryPrice: null, stockCurrency: null, hasBenchmarkEntryPrice: false, relativeReturnToday: null, relativeReturnLifetime: null, pricingProgress: null, stockPriceExpectation: null}));
    }
    const performanceTable = {};
    ideaPerformance.forEach(p => {
        performanceTable[p.ideaId] = p;
    });
    return openIdeas.map(idea => {
        const p = performanceTable[idea.ideaId];
        if (p) {
            const hasBenchmarkEntryPrice = (p.benchmarkEntryPrice !== null);
            const {stockEntryPrice,
                   pricingProgress,
                   stockEntryPriceCurrency: stockCurrency,
                   todayRelRet: relativeReturnToday,
                   lifetimeRelRet: relativeReturnLifetime,
                   stockPriceExpectation} = p;
            return ({...idea, pricingProgress, relativeReturnToday, relativeReturnLifetime, stockEntryPrice, stockCurrency, hasBenchmarkEntryPrice, stockPriceExpectation});
        } else {
            return ({...idea, stockEntryPrice: null, stockCurrency: null, hasBenchmarkEntryPrice: false, relativeReturnToday: null, relativeReturnLifetime: null, pricingProgress: null, stockPriceExpectation: null});
        }
    });
}

export function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case "SUBSCRIPTION_DATA_ARRIVED/AUTHOR_HOMEPAGE":
            const content = {
                ...action.payload,
                openIdeas: addEarningsSort(addPerformance(
                    addTimeOpenToIdeas(action.payload.openIdeas),
                    state.openIdeasPerformance
                ))
            };
            return {...state, content: content};
        case "SUBSCRIPTION_DATA_ARRIVED/OPEN_IDEAS_PERFORMANCE":
            if (state.content) {
                return {
                    ...state,
                    openIdeasPerformance: action.payload,
                    content: {...state.content, openIdeas: addPerformance(state.content.openIdeas, action.payload)}
                };
            } else {
                return {...state, openIdeasPerformance: action.payload};
            }
        case "SET_IDEA_ACTION": {
            const selectedIdeaAction = action.payload.action;
            return {...state, selectedIdeaAction}
        }
        case "TOGGLE_QUICK_EDIT": {
            const ideaId = action.payload.ideaId;
            const editingIdeaId = state.editingIdeaId === ideaId ? null : ideaId;
            return {...state, editingIdeaId, selectedIdeaAction: null}
        }
        case "AUTHOR_ACTIONS/TOGGLE_CREATE_SCREEN":
            return {...state, createModalVisible: action.payload.show};
        case "AUTHOR_ACTIONS/SORT_OPEN_IDEAS_BY": {
            const {sortField, descendingFirst} = action.payload;
            const openIdeasSort = state.openIdeasSort.requestSortBy(sortField, descendingFirst);
            return {...state, openIdeasSort};
        }
        case "AUTHOR_ACTIONS/SORT_PORTFOLIOS_BY": {
            const {sortField, descendingFirst} = action.payload;
            const portfolioSort = state.portfolioSort.requestSortBy(sortField, descendingFirst);
            return {...state, portfolioSort};
        }
        default:
            return state;
    }
}

export function setIdeaAction(action) {
    return {type: "SET_IDEA_ACTION", payload: {action}};
}

export function hideQuickEdit() {
    return {type: "TOGGLE_QUICK_EDIT", payload: {ideaId: null}};
}

export function toggleQuickEdit(ideaId) {
    return {type: "TOGGLE_QUICK_EDIT", payload: {ideaId}};
}

export function setCreateModalVisible(show) {
    return {type: "AUTHOR_ACTIONS/TOGGLE_CREATE_SCREEN", payload: {show}};
}

export function sortOpenIdeasBy(sortField, descendingFirst = true) {
    return {type: "AUTHOR_ACTIONS/SORT_OPEN_IDEAS_BY", payload: {sortField, descendingFirst}};
}

export function sortPortfoliosBy(sortField, descendingFirst = true) {
    return {type: "AUTHOR_ACTIONS/SORT_PORTFOLIOS_BY", payload: {sortField, descendingFirst}};
}

export default dispatch => ({
    setIdeaAction(action) {
        dispatch(setIdeaAction(action));
    },

    toggleQuickEdit(ideaId) {
        dispatch(hideNotifications());
        dispatch(toggleQuickEdit(ideaId));
    },

    hideQuickEdit() {
        dispatch(hideQuickEdit());
    },

    showCreateScreen() {
        dispatch(setCreateModalVisible(true));
    },

    hideCreateScreen() {
        dispatch(setCreateModalVisible(false));
    },

    sortOpenIdeasBy(sortField, descendingFirst) {
        dispatch(sortOpenIdeasBy(sortField, descendingFirst));
    },

    sortPortfoliosBy(sortField, descendingFirst) {
        dispatch(sortPortfoliosBy(sortField, descendingFirst));
    }
});
